'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { RequestStatusRecord } from 'AdsUI/records/RequestStatus';
import { fetchCampaignBreakdowns } from 'AdsUI/actions/CampaignReportingActions';
import { getProcessedFbBreakdownFunnels } from 'AdsUI/selectors/LeadAdCampaignSelectors';
import { getCampaignForCampaignDetails, getCampaignRequestStatus } from 'AdsUI/selectors/CampaignReportingSelectors';
import CampaignDetailsAnalyze from 'AdsUI/components/campaign-details/CampaignDetailsAnalyze';
import { getGlobalFilters } from 'AdsUI/selectors/GlobalFilters';
import { getAdAccountFromParams } from 'AdsUI/selectors/AccountsSelectors';
import { getNetworkFromParams } from 'AdsUI/selectors/PropsSelectors';

const CampaignDetailsAnalyzeContainer = ({
  adAccount,
  network,
  campaignBreakdowns,
  campaignDetails,
  campaignBreakdownsRequestStatus,
  globalFilters,
  match: {
    params: {
      accountId,
      campaignId
    }
  },
  dispatch
}) => {
  useEffect(() => {
    if (globalFilters.initialized) {
      dispatch(fetchCampaignBreakdowns(accountId, campaignId, globalFilters.timeRange));
    }
  }, [dispatch, globalFilters, accountId, campaignId]);
  return /*#__PURE__*/_jsx(CampaignDetailsAnalyze, {
    loadingBreakdowns: !campaignBreakdownsRequestStatus.fetchedSuccessfully(),
    network: network,
    adAccount: adAccount,
    campaignDetails: campaignDetails,
    campaignBreakdowns: campaignBreakdowns
  });
};

const mapStateToProps = (state, props) => {
  const {
    match: {
      params
    }
  } = props;
  return {
    campaignBreakdowns: getProcessedFbBreakdownFunnels(state, props),
    campaignBreakdownsRequestStatus: state.requestStatus.fbBreakdownFunnels.get(params.campaignId, new RequestStatusRecord()),
    campaignDetails: getCampaignForCampaignDetails(state, props),
    campaignDetailsRequestStatus: getCampaignRequestStatus(state, props),
    adAccount: getAdAccountFromParams(state, props),
    network: getNetworkFromParams(state, props),
    globalFilters: getGlobalFilters(state)
  };
};

export default connect(mapStateToProps)(CampaignDetailsAnalyzeContainer);